module.exports = __webpack_public_path__ + "static/media/13.711d9388.png";